export class ErrorResponse {
  // eslint-disable-next-line no-useless-constructor
  constructor (public message: string, public status: number | undefined) {
  }
}

export class UnauthorizedError extends ErrorResponse {
  constructor (public message: string, public status: number) {
    super(message, status)
  }
}

export class NotFoundError extends ErrorResponse {
  constructor (public message: string, public status: number) {
    super(message, status)
  }
}

export class InternalServerError extends ErrorResponse {
  constructor (public message: string, public status: number) {
    super(message, status)
  }
}

export class ValidationError {
  // eslint-disable-next-line no-useless-constructor
  constructor (public message: Record<string, string[]>, public status: number) {
  }
}
